import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

//#region imports
import CustomLayout from "@layouts/custom-layout.vue";
import PageMeditation from "@pages/page-meditation/page-meditation.vue";
import PageCreateMeditation from "@pages/page-meditation/page-create-meditation.vue";
import PageAffirmation from "@pages/page-affirmation/page-affirmation.vue";
import PageCreateAffirmation from "@pages/page-affirmation/page-create-affirmation.vue";
import PageBreathing from "@pages/page-breathing/page-breathing.vue";
import PageCreateBreathing from "@pages/page-breathing/page-create-breathing.vue";
import PageMeditationCategories from "@pages/page-meditation/page-meditation-categories.vue";
import PageCreateMeditationCategory from "@pages/page-meditation/page-create-meditation-category.vue";

import PageSleepStories from "@pages/sleep-story/page-sleep-stories.vue";
import PageSleepStoryCategories from "@pages/sleep-story/page-sleep-story-categories.vue";
import PageCreateSleepStoryCategory from "@pages/sleep-story/page-sleep-story-category.vue";

import PageCreateSleepStory from "@pages/sleep-story/page-create-sleep-story.vue";
import PageMusic from "@pages/page-music/page-music.vue";
import MusicCategoriesPage from "@pages/page-music/page-music-categories.vue";
import CreateMusicCategoryPage from "@pages/page-music/page-music-category.vue";
import PageNatureSound from "@pages/page-nature-sound/page-nature-sound.vue";
import PageCreateNatureSound from "@pages/page-nature-sound/page-create-nature-sound.vue";
import PageNatureSoundMixes from "@pages/page-nature-sound/page-nature-sound-mixes.vue";
import PageCreateNatureSoundMix from "@pages/page-nature-sound/page-create-nature-sound-mix.vue";

import PageCreateMusic from "@pages/page-music/page-create-music.vue";
import PageUsers from "@pages/page-users/page-users.vue";
import PagePromocodes from "@pages/page-promocodes/page-promocodes.vue";
import PageCreatePromocode from "@pages/page-promocodes/page-create-promocode.vue";
import PageEmailPush from "@pages/page-email-push/page-email-push.vue";
import PageCreateEmailPush from "@pages/page-email-push/page-create-email-push.vue";
import PageInspiration from "@pages/page-inspiration/page-inspiration.vue";
import PageCreateInspiration from "@pages/page-inspiration/page-create-inspiration.vue";
import PageReminders from "@pages/page-reminder/page-reminder.vue";
import PageCreateReminder from "@pages/page-reminder/page-create-reminder.vue";
import PageOther from "@pages/other/other.vue";
import PageLogin from "@pages/page-login/page-login.vue";
import PageLanguage from "@pages/page-language/page-language.vue";
import PageAnimation from "@pages/page-animation/page-animation.vue";
import PageCreateAnimation from "@pages/page-animation/page-create-animation.vue";
import PageProfile from "@pages/page-profile/page-profile.vue";
import PageDocuments from "@pages/page-documents/page-documents.vue";
import PageDocumentsEdit from "@pages/page-documents/page-documents-edit.vue";
import PageStatistics from "@pages/page-statistics/page-statistics.vue";
import { PageLevel, PageCreateLevel, PageReward, PageCreateReward } from "./pages";

import MenuComponent from "./components/menu/main-menu/ui-menu.vue";
import AuthGuardBase from "./middlewares/authGuardBase";
import DocumentTitleMiddleware from "./middlewares/documentTitleMiddleware";
import {
  LEVEL_LIST,
  LEVEL_CREATE,
  LEVEL_EDIT,
  AFFIRMATION_CREATE,
  AFFIRMATION_EDIT,
  AFFIRMATION_LIST,
  ANIMATION_CREATE,
  ANIMATION_EDIT,
  ANIMATION_LIST,
  BREATHING_CREATE,
  BREATHING_EDIT,
  BREATHING_LIST,
  DOCUMENTS,
  DOCUMENTS_EDIT,
  EMAIL_PUSH_CREATE,
  EMAIL_PUSH_EDIT,
  EMAIL_PUSH_LIST,
  INSPIRATION_CREATE,
  INSPIRATION_EDIT,
  INSPIRATION_LIST,
  LANGUAGES_LIST,
  LOGIN_PAGE,
  MEDIDATION_CATEGORY_CREATE,
  MEDIDATION_CATEGORY_EDIT,
  MEDIDATION_CATEGORY_LIST,
  MEDIDATION_CREATE,
  MEDIDATION_EDIT,
  MEDIDATION_LIST,
  MUSIC_CREATE,
  MUSIC_EDIT,
  MUSIC_LIST,
  MUSIC_NATURE_SOUND_CREATE,
  MUSIC_NATURE_SOUND_EDIT,
  MUSIC_NATURE_SOUND_LIST,
  PROFILE,
  PROMOCODE_CREATE,
  PROMOCODE_EDIT,
  PROMOCODE_LIST,
  REMINDER_CREATE,
  REMINDER_EDIT,
  REMINDER_LIST,
  SLEEP_STORY_CREATE,
  SLEEP_STORY_EDIT,
  SLEEP_STORY_LIST,
  USER_LIST,
  STATISTICS,
  MUSIC_CATEGORY_LIST,
  MUSIC_CATEGORY_CREATE,
  MUSIC_CATEGORY_EDIT,
  SLEEP_STORY_CATEGORY_LIST,
  SLEEP_STORY_CATEGORY_CREATE,
  SLEEP_STORY_CATEGORY_EDIT,
  MUSIC_NATURE_SOUND_MIX_LIST,
  MUSIC_NATURE_SOUND_MIX_CREATE,
  MUSIC_NATURE_SOUND_MIX_EDIT,
  REWARD_LIST,
  REWARD_CREATE,
  REWARD_EDIT,
} from "./route-names";
//#endregion

const router = new VueRouter({
  mode: "history",
  routes: [
    {
      path: "/page-login",
      name: LOGIN_PAGE,
      component: PageLogin,
      meta: {
        title: "Авторизация",
        middleware: [new DocumentTitleMiddleware()],
      },
    },
    {
      path: "/",
      name: "default",
      component: CustomLayout,
      redirect: "/meditations",
      meta: {
        authorize: true,
        middleware: [new AuthGuardBase(LOGIN_PAGE)],
      },
      children: [
        {
          name: AFFIRMATION_LIST,
          path: "affirmations",
          meta: {
            title: "Аффирмации",
          },
          components: {
            default: PageAffirmation,
            menu: MenuComponent,
          },
        },
        {
          name: AFFIRMATION_CREATE,
          path: "affirmations/create",
          meta: {
            title: "Создать аффирмацию",
          },
          components: {
            default: PageCreateAffirmation,
            menu: MenuComponent,
          },
        },
        {
          name: AFFIRMATION_EDIT,
          path: "affirmations/edit/:id",
          props: true,
          meta: {
            title: "Редактировать аффирмацию",
          },
          components: {
            default: PageCreateAffirmation,
            menu: MenuComponent,
          },
        },
        {
          name: BREATHING_LIST,
          path: "breathing",
          meta: {
            title: "Дыхание",
          },
          components: {
            default: PageBreathing,
            menu: MenuComponent,
          },
        },
        {
          name: BREATHING_CREATE,
          path: "breathing/create",
          meta: {
            title: "Создать дыхание",
          },
          components: {
            default: PageCreateBreathing,
            menu: MenuComponent,
          },
        },
        {
          name: BREATHING_EDIT,
          path: "breathing/edit/:id",
          props: true,
          meta: {
            title: "Редактировать дыхание",
          },
          components: {
            default: PageCreateBreathing,
            menu: MenuComponent,
          },
        },
        {
          name: MEDIDATION_LIST,
          path: "meditations",
          meta: {
            title: "Медитации",
          },
          components: {
            default: PageMeditation,
            menu: MenuComponent,
          },
        },
        {
          name: MEDIDATION_CATEGORY_LIST,
          path: "meditation-categories",
          meta: {
            title: "Категории медитаций",
          },
          components: {
            default: PageMeditationCategories,
            menu: MenuComponent,
          },
        },
        {
          name: MEDIDATION_CREATE,
          path: "create-meditation",
          components: {
            default: PageCreateMeditation,
            menu: MenuComponent,
          },
        },
        {
          name: MEDIDATION_EDIT,
          path: "edit-meditation/:id",
          props: true,
          components: {
            default: PageCreateMeditation,
            menu: MenuComponent,
          },
        },
        {
          name: MEDIDATION_CATEGORY_CREATE,
          path: "create-meditation-category",
          components: {
            default: PageCreateMeditationCategory,
            menu: MenuComponent,
          },
        },
        {
          name: MEDIDATION_CATEGORY_EDIT,
          path: "edit-meditation-category/:id",
          props: true,
          components: {
            default: PageCreateMeditationCategory,
            menu: MenuComponent,
          },
        },

        {
          name: SLEEP_STORY_LIST,
          path: "sleep-stories",
          meta: {
            title: "Сонные истории",
          },
          components: {
            default: PageSleepStories,
            menu: MenuComponent,
          },
        },
        {
          name: SLEEP_STORY_CATEGORY_LIST,
          path: "sleep-story-categories",
          meta: {
            title: "Категории сонных историй",
          },
          components: {
            default: PageSleepStoryCategories,
            menu: MenuComponent,
          },
        },
        {
          name: SLEEP_STORY_CATEGORY_CREATE,
          path: "create-sleep-story-category",
          components: {
            default: PageCreateSleepStoryCategory,
            menu: MenuComponent,
          },
        },
        {
          name: SLEEP_STORY_CATEGORY_EDIT,
          path: "edit-sleep-story-category/:id",
          components: {
            default: PageCreateSleepStoryCategory,
            menu: MenuComponent,
          },
        },

        {
          name: SLEEP_STORY_CREATE,
          path: "create-sleep-story",
          components: {
            default: PageCreateSleepStory,
            menu: MenuComponent,
          },
        },
        {
          name: SLEEP_STORY_EDIT,
          path: "edit-sleep-story/:id",
          props: true,
          components: {
            default: PageCreateSleepStory,
            menu: MenuComponent,
          },
        },
        {
          name: MUSIC_LIST,
          path: "music",
          components: {
            default: PageMusic,
            menu: MenuComponent,
          },
        },
        {
          name: MUSIC_CATEGORY_LIST,
          path: "music-categories",
          meta: {
            title: "Категории музыки",
          },
          components: {
            default: MusicCategoriesPage,
            menu: MenuComponent,
          },
        },
        {
          name: MUSIC_CATEGORY_CREATE,
          path: "create-music-category",
          components: {
            default: CreateMusicCategoryPage,
            menu: MenuComponent,
          },
        },
        {
          name: MUSIC_CATEGORY_EDIT,
          path: "edit-music-category/:id",
          components: {
            default: CreateMusicCategoryPage,
            menu: MenuComponent,
          },
        },

        {
          name: MUSIC_NATURE_SOUND_LIST,
          path: "nature-sound",
          components: {
            default: PageNatureSound,
            menu: MenuComponent,
          },
        },
        {
          name: MUSIC_NATURE_SOUND_CREATE,
          path: "create-nature-sound",
          components: {
            default: PageCreateNatureSound,
            menu: MenuComponent,
          },
        },
        {
          name: MUSIC_NATURE_SOUND_EDIT,
          path: "edit-nature-sound/:id",
          props: true,
          components: {
            default: PageCreateNatureSound,
            menu: MenuComponent,
          },
        },

        {
          name: MUSIC_NATURE_SOUND_MIX_LIST,
          path: "nature-sound-mix",
          components: {
            default: PageNatureSoundMixes,
            menu: MenuComponent,
          },
        },
        {
          name: MUSIC_NATURE_SOUND_MIX_CREATE,
          path: "create-nature-sound-mix",
          components: {
            default: PageCreateNatureSoundMix,
            menu: MenuComponent,
          },
        },
        {
          name: MUSIC_NATURE_SOUND_MIX_EDIT,
          path: "edit-nature-sound-mix/:id",
          props: true,
          components: {
            default: PageCreateNatureSoundMix,
            menu: MenuComponent,
          },
        },

        {
          name: MUSIC_CREATE,
          path: "create-music",
          components: {
            default: PageCreateMusic,
            menu: MenuComponent,
          },
        },
        {
          name: MUSIC_EDIT,
          path: "edit-music/:id",
          components: {
            default: PageCreateMusic,
            menu: MenuComponent,
          },
        },
        {
          name: USER_LIST,
          path: "users",
          components: {
            default: PageUsers,
            menu: MenuComponent,
          },
        },
        {
          name: PROMOCODE_LIST,
          path: "promocodes",
          components: {
            default: PagePromocodes,
            menu: MenuComponent,
          },
        },
        {
          name: PROMOCODE_CREATE,
          path: "create-promocode",
          components: {
            default: PageCreatePromocode,
            menu: MenuComponent,
          },
        },
        {
          name: PROMOCODE_EDIT,
          path: "edit-promocode/:id",
          props: true,
          components: {
            default: PageCreatePromocode,
            menu: MenuComponent,
          },
        },
        {
          name: EMAIL_PUSH_LIST,
          path: "email-push",
          components: {
            default: PageEmailPush,
            menu: MenuComponent,
          },
        },
        {
          name: EMAIL_PUSH_CREATE,
          path: "create-email-push",
          components: {
            default: PageCreateEmailPush,
            menu: MenuComponent,
          },
        },
        {
          name: EMAIL_PUSH_EDIT,
          path: "edit-email-push/:id",
          props: true,
          components: {
            default: PageCreateEmailPush,
            menu: MenuComponent,
          },
        },
        {
          name: INSPIRATION_LIST,
          path: "inspiration",
          components: {
            default: PageInspiration,
            menu: MenuComponent,
          },
        },
        {
          name: INSPIRATION_CREATE,
          path: "create-inspiration",
          components: {
            default: PageCreateInspiration,
            menu: MenuComponent,
          },
        },
        {
          name: INSPIRATION_EDIT,
          path: "edit-inspiration/:id",
          props: true,
          components: {
            default: PageCreateInspiration,
            menu: MenuComponent,
          },
        },
        {
          name: REMINDER_LIST,
          path: "reminder",
          components: {
            default: PageReminders,
            menu: MenuComponent,
          },
        },
        {
          name: REMINDER_CREATE,
          path: "create-reminder",
          components: {
            default: PageCreateReminder,
            menu: MenuComponent,
          },
        },
        {
          name: REMINDER_EDIT,
          path: "edit-reminder/:id",
          props: true,
          components: {
            default: PageCreateReminder,
            menu: MenuComponent,
          },
        },
        {
          name: LANGUAGES_LIST,
          path: "languages",
          components: {
            default: PageLanguage,
            menu: MenuComponent,
          },
        },
        {
          name: ANIMATION_LIST,
          path: "animations",
          components: {
            default: PageAnimation,
            menu: MenuComponent,
          },
        },
        {
          name: ANIMATION_CREATE,
          path: "animations/create",
          components: {
            default: PageCreateAnimation,
            menu: MenuComponent,
          },
        },
        {
          name: ANIMATION_EDIT,
          path: "animations/edit/:id",
          props: true,
          components: {
            default: PageCreateAnimation,
            menu: MenuComponent,
          },
        },
        {
          name: PROFILE,
          path: "profile",
          components: {
            default: PageProfile,
            menu: MenuComponent,
          },
        },
        {
          name: "other",
          path: "other/:id?",
          component: PageOther,
        },
        {
          name: DOCUMENTS,
          path: "documents",
          components: {
            default: PageDocuments,
            menu: MenuComponent,
          },
        },
        {
          name: DOCUMENTS_EDIT,
          path: "documents/edit/:id",
          props: true,
          components: {
            default: PageDocumentsEdit,
            menu: MenuComponent,
          },
        },
        {
          name: STATISTICS,
          path: "statistics",
          props: true,
          components: {
            default: PageStatistics,
            menu: MenuComponent,
          },
        },
        {
          name: LEVEL_LIST,
          path: "levels",
          meta: {
            title: "Уровни",
          },
          components: {
            default: PageLevel,
            menu: MenuComponent,
          },
        },
        {
          name: LEVEL_CREATE,
          path: "create-level",
          components: {
            default: PageCreateLevel,
            menu: MenuComponent,
          },
        },
        {
          name: LEVEL_EDIT,
          path: "edit-level/:id",
          props: true,
          components: {
            default: PageCreateLevel,
            menu: MenuComponent,
          },
        },

        {
          name: REWARD_LIST,
          path: "rewards",
          meta: {
            title: "Награды",
          },
          components: {
            default: PageReward,
            menu: MenuComponent,
          },
        },
        {
          name: REWARD_CREATE,
          path: "create-reward",
          components: {
            default: PageCreateReward,
            menu: MenuComponent,
          },
        },
        {
          name: REWARD_EDIT,
          path: "edit-reward/:id",
          props: true,
          components: {
            default: PageCreateReward,
            menu: MenuComponent,
          },
        },
      ],
    },
  ],
});
export default router;
